import { mapState } from 'vuex'
import TheBreadcrumbs from '@/components/common/TheBreadcrumbs/TheBreadcrumbs'
import DataTable from '@/components/common/DataTable/DataTable'
import BookmarkDialog from '@/components/page/BookmarkDialog/BookmarkDialog'
import _ from 'lodash'
import Constants from '@/utils/Constants'
import ApiManager from '@/utils/ApiManager'

export default {
  name: 'pagebookmarklist',
  layout: 'LayoutDefault',
  components: {
    TheBreadcrumbs: TheBreadcrumbs,
    DataTable: DataTable,
    BookmarkDialog: BookmarkDialog
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'ダッシュボード',
        disabled: false,
        href: '/'
      },
      {
        text: 'ブックマーク一覧',
        disabled: true,
        href: ''
      }
    ],
    searchWord: '',
    company: 0,
    companies: [
      { text: 'A会社', value: '1' },
      { text: 'B会社', value: '2' }
    ],
    selectionState: { selectedCount: 0, disableAllSelected: true },
    showEditBookmark: false,
    bookmarkItem: {
      id: -1,
      memo: '',
      publicSetting: 'Private'
    }
  }),
  created () {
    console.log('BookmarkList created')
  },
  filters: {
  },
  computed: {
    ...mapState({
      list: state => state.pagebookmarklist.list
    }),
    bookmark_publish_setting_flag () {
      return Constants.getContract('bookmark_publish_setting_flag')
    }
  },
  methods: {
    onSelectionChanged (selection, disableAllSelected) {
      this.selectionState = {
        selectedCount: selection.length,
        disableAllSelected: disableAllSelected
      }
    },
    refreshPage () {
      this.getBookmarkList(
        1,
        null,
        null
      )
    },
    onPagination (pagination) {
      this.getBookmarkList(
        pagination.page,
        pagination.sortBy,
        pagination.descending,
        this.searchWord
      )
    },
    onDeleteItems (items) {
      let deleteIds = _.map(items, 'id')
      this.$store.dispatch('pagebookmarklist/doDelete', deleteIds)
      console.log(deleteIds)
    },
    onEdit (item) {
      let editData = _.clone(item)
      if (this.bookmark_publish_setting_flag === 0) {
        editData.publishSetting = '0'
      } else {
        if (editData.publish_setting === 'Public') {
          editData.publishSetting = '1'
        } else {
          editData.publishSetting = '0'
        }
      }
      ApiManager.request('History').historyDetail(editData.history_id).then(response => {
        if (response.data.code === 200000) {
          editData.historyPublishSetting = response.data.data.publish_setting
        } else {
          editData.historyPublishSetting = 0
        }
        this.$refs.bookmarkDialog.editData = editData
        this.showEditBookmark = true
      })
    },
    onClose () {
      this.showEditBookmark = false
    },
    onUpdateBookmark (editData) {
      this.doUpdateBookmark(editData)
      this.showEditBookmark = false
    },
    getBookmarkList (pageNo, sortField, sortType) {
      this.$store.dispatch('pagebookmarklist/getBookmarkList', {
        pageNo: pageNo,
        sortField: sortField,
        sortType: sortType
      })
    },
    doUpdateBookmark (editData) {
      this.$store.dispatch('pagebookmarklist/doUpdate', editData)
    }
  },
  metaInfo () {
    this.$store.dispatch('meta/set', {
      title: 'ブックマーク一覧',
      meta: [
        {
          name: 'description',
          content: 'ブックマーク一覧'
        }
      ]
    })
    return this.$store.getters['meta/get']
  }
}
